import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44905a06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "quiz-loading-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Fórmula Pronta!", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text" }, "Sua fórmula contém", -1))
const _hoisted_6 = { class: "product-items" }
const _hoisted_7 = { class: "text product-list-item" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Quero minha fórmula!")
const _hoisted_10 = { key: 2 }
const _hoisted_11 = {
  key: 0,
  class: "question"
}
const _hoisted_12 = { class: "question-container" }
const _hoisted_13 = { class: "question-head" }
const _hoisted_14 = { class: "question-title" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { class: "question-tip" }
const _hoisted_18 = { class: "text" }
const _hoisted_19 = {
  key: 0,
  class: "text-container"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "question-group-title text" }
const _hoisted_22 = { class: "question-group" }
const _hoisted_23 = { class: "question-group" }

import { defineComponent, ref } from "vue";
import { store } from "../store";
import Loading from "@/assets/img/skinker-loading.gif";

import {
  NButton,
  NSpace,
  NAlert,
  NLayout,
  NRadioGroup,
  NCard,
  NInput,
  NCheckbox,
  NTooltip,
  NRadio,
  NCheckboxGroup,
  NImage,
  NGrid,
} from "naive-ui";
import { InfoOutlined } from "@vicons/material";

import Tooltip from "./Tooltip.vue";
import Stepper from "./Stepper/Stepper.vue";
import Answers from "./Answers/Answers.vue";
import questions from "../questions.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'Quiz',
  setup(__props) {

defineComponent({
  name: "Quiz",
  data() {
    return {
      store,
    };
  },
  components: {
    NGrid,
    NButton,
    NSpace,
    NAlert,
    NLayout,
    NRadioGroup,
    NCard,
    NInput,
    NCheckbox,
    NTooltip,
    InfoOutlined,
    NRadio,
    NCheckboxGroup,
    NImage,
    Tooltip,
  },
});

const questionActive = ref(1);
const product = ref(null);
const loading = ref(false); 
const showError = ref(false);
const errorMessage = ref("");
const productResponse = ref(null);
const quizLength = ref(questions.length);
const quizQuestions = ref(questions);
const stepperDisabled = ref(true);

const handleStepperChanges = (step: number) => {
  questionActive.value = step;
  stepperDisabled.value = true;

  const questionName = quizQuestions.value[step - 1].name;

  if (store[questionName]) {
    stepperDisabled.value = false;
  }
};

const handleAnswerChange = (question) => {
  const { dependency } = question;

  if (dependency) {
    if (store[question.name] === dependency?.value) {
      quizQuestions.value = quizQuestions.value.filter(
        (q) => !store[q.dependency]
      );
    } else {
      quizQuestions.value = quizQuestions.value.filter(
        (q) => q.name != dependency.name
      );
    }

    quizLength.value = quizQuestions.value.length;
  }

  if (store.politica === "Não") {
    stepperDisabled.value = true;
    return;
  }

  if (store[question.name]) {
    stepperDisabled.value = false;
  }
};

const handleError = (error) => {
  return (
    error?.response?.data?.error || "Erro na solicitação, tente novamente!"
  );
};

const handleFinishQuiz = async () => {
  const { objetivos } = store;

  loading.value = true;

  const payload = {
    ...store,
    ...{ objetivos: objetivos.toString() },
  };

  $.ajax({
    url: ajax_config.url,
    data: {
      action: "post_quiz",
      payload,
    },

    method: "POST",
    success: (res) => {
      const response = JSON.parse(res);

      if (response.error) {
        loading.value = false;
        errorMessage.value = handleError(response.error);
        showError.value = true;
      }

      product.value = response.priceOpt[0];
      productResponse.value = response;
      loading.value = false;
    },
    error: () => {},
  });
};

const handleSelectProduct = async () => {
  loading.value = true;
  showError.value = false;
  const answers = store;

  await $.ajax({
    url: ajax_config.url,
    data: {
      action: "create_product_ajax",
      data: {
        answers,
        ...productResponse,
      },
    },
    method: "POST",
    success: (res) => {
      window.location.href = res.data.url;
      loading.value = false;
    },
    error: function () {
      showError.value = true;
      loading.value = false;
    },
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NSpace), {
    vertical: "",
    class: "quiz-container"
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _unref(Loading),
              alt: "Carregamento",
              class: "quiz-loading"
            }, null, 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      (product.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(NSpace), {
              size: "large",
              vertical: ""
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.priceMaterialOptions, (formula) => {
                    return (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                      _createElementVNode("li", null, [
                        _createElementVNode("p", _hoisted_8, [
                          _createElementVNode("strong", null, _toDisplayString(formula.material) + ": ", 1),
                          _createTextVNode(" " + _toDisplayString(formula.description), 1)
                        ])
                      ])
                    ]))
                  }), 256))
                ]),
                _createVNode(_unref(NButton), {
                  type: "primary",
                  onClick: handleSelectProduct
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(Stepper, {
              "stepper-length": quizLength.value,
              onStepperChanges: handleStepperChanges,
              onStepperFinish: handleFinishQuiz,
              "stepper-disabled": stepperDisabled.value
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quizQuestions.value, (question, index) => {
                  return (_openBlock(), _createElementBlock("div", null, [
                    _createVNode(_Transition, { name: "slide-fade" }, {
                      default: _withCtx(() => [
                        (index + 1 === questionActive.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("h2", _hoisted_15, _toDisplayString(question.title), 1),
                                    _createElementVNode("p", _hoisted_16, _toDisplayString(question.add), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("p", _hoisted_18, _toDisplayString(question.tip), 1)
                                  ])
                                ]),
                                (question.type === 'text')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(_unref(NInput), {
                                        type: "text",
                                        value: _unref(store)[question.name],
                                        "onUpdate:value": ($event: any) => ((_unref(store)[question.name]) = $event),
                                        "on-change": handleAnswerChange(question),
                                        size: "large",
                                        round: "",
                                        placeholder: question.label
                                      }, null, 8, ["value", "onUpdate:value", "on-change", "placeholder"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (question.group)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.group, (questionGroup) => {
                                        return (_openBlock(), _createElementBlock("div", null, [
                                          _createElementVNode("p", _hoisted_21, _toDisplayString(questionGroup.title), 1),
                                          _createElementVNode("div", _hoisted_22, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionGroup.answers, (answer) => {
                                              return (_openBlock(), _createElementBlock("div", null, [
                                                _createVNode(Answers, {
                                                  question: questionGroup,
                                                  answer: answer,
                                                  onChange: ($event: any) => (handleAnswerChange(questionGroup))
                                                }, null, 8, ["question", "answer", "onChange"])
                                              ]))
                                            }), 256))
                                          ])
                                        ]))
                                      }), 256))
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_23, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question.answers, (answer) => {
                                    return (_openBlock(), _createElementBlock("div", null, [
                                      _createVNode(Answers, {
                                        question: question,
                                        answer: answer,
                                        onChange: ($event: any) => (handleAnswerChange(question))
                                      }, null, 8, ["question", "answer", "onChange"])
                                    ]))
                                  }), 256))
                                ])
                              ]),
                              (showError.value)
                                ? (_openBlock(), _createBlock(_unref(NAlert), {
                                    key: 0,
                                    type: "error"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(errorMessage.value), 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 256))
              ]),
              _: 1
            }, 8, ["stepper-length", "stepper-disabled"])
          ]))
    ]),
    _: 1
  }))
}
}

})